import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { CloseIcon } from "@smartsheet/lodestar-icons";
import { toggleTheme } from "./toggleTheme";
export var ToggleOffIcon = styled(CloseIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    transition: opacity ", ";\n    opacity: ", ";\n    position: relative;\n    right: 5px;\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return toggleTheme.motion.animation(themeMode);
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 1 : 0;
});
//# sourceMappingURL=ToggleOffIcon.js.map